import React from 'react';
import WarningIcon from '../assets/alert-warning.svg';
import './WarningBox.css';

interface WarningBoxProps {
  title: string;
  children: React.ReactNode;
}

const WarningBox: React.FC<WarningBoxProps> = ({ title, children }) => {
  return (
    <div className="warning-box">
      <div className="warning-box-content">
        <div className="warning-box-icon">
          <img src={WarningIcon} alt="warning" className="warning-icon" />
        </div>
        <div className="warning-box-text">
          <h4>{title}</h4>
          <div className="warning-box-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default WarningBox;
